var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3553 17.264C23.53 17.4679 23.626 17.7275 23.626 17.996C23.626 18.2645 23.53 18.5241 23.3553 18.728L14.3553 29.228C14.2591 29.3403 14.1418 29.4325 14.0101 29.4994C13.8783 29.5664 13.7346 29.6067 13.5872 29.6182C13.4399 29.6296 13.2917 29.6119 13.1512 29.566C13.0107 29.5202 12.8805 29.4471 12.7683 29.351C12.656 29.2548 12.5637 29.1375 12.4968 29.0058C12.4298 28.874 12.3895 28.7303 12.3781 28.5829C12.3667 28.4356 12.3844 28.2874 12.4302 28.1469C12.4761 28.0064 12.5491 27.8763 12.6453 27.764L21.0198 17.996L12.6483 8.22797C12.5464 8.11675 12.468 7.98618 12.4176 7.84402C12.3672 7.70187 12.3459 7.55104 12.355 7.4005C12.3641 7.24995 12.4033 7.10277 12.4704 6.9677C12.5375 6.83263 12.6311 6.71243 12.7456 6.61425C12.86 6.51607 12.9931 6.4419 13.1368 6.39617C13.2805 6.35044 13.432 6.33407 13.5821 6.34804C13.7323 6.362 13.8781 6.40602 14.0109 6.47748C14.1438 6.54893 14.2609 6.64636 14.3553 6.76397L23.3553 17.264Z",
    fill: "#253331"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronArrow);
export default __webpack_public_path__ + "static/media/chevron-arrow.f76b33f183a63f9adfd2449f000789a0.svg";
export { ForwardRef as ReactComponent };